module.exports = __webpack_public_path__ + "static/flags/IS-5e283be5204ba236ad7442075eea34c2.gif";